import {RouteComponentProps, withRouter} from "react-router-dom";
import React from "react";
import {useTypedSelector} from "helpers/reducers";
import {Hall} from "types/entities/Hall";
import {HallCode} from "types/enums/HallCode";
import {DEFAULT_HALL, IS_DEV, ROOT_STORAGE_WEB} from "helpers/config";

interface LogoNewProps extends RouteComponentProps {}

const LogoNew = (props: LogoNewProps) => {
    const hall = useTypedSelector<Hall | null>(state => state.hallState.hall) || null;
    const location = props.location.pathname;
    const homeUrl = hall && location.includes("/booking") ? (DEFAULT_HALL === HallCode.ArboPark ? "https://" + hall.domain : "https://" + hall.app_url) : "/";

    return (
        <div
            className={
                "max-w-[170px] sm:max-w-[153px] lg:max-w-[192px] xl:max-w-[264px] w-full sm:bg-white sm:shadow-lg sm:rounded-bl-[20px] sm:rounded-br-[20px] sm:ml-8 lg:ml-2 xl:ml-8 2xl:ml-[100px] sm:px-4 sm:py-5"
            }
        >
            <a aria-current="page" className={"h-full flex"} href={homeUrl}>
                <img
                    alt={hall ? hall.name : "Logo"}
                    className={"object-contain mx-auto w-full h-auto"}
                    src={hall ? (IS_DEV ? hall.image.replace("/img/", ROOT_STORAGE_WEB + "/img/") : hall.image) : ""}
                />
            </a>
        </div>
    );
};

export default withRouter(LogoNew);
